// Central API configuration
// Change this single value to switch between local and production backend
const API_BASE_URL = 'https://avitech-backend-dev-production.up.railway.app';
//const API_BASE_URL = 'http://localhost:8080'; // LOKAL TEST — push'tan önce üstteki Railway satırına geri al!

export default API_BASE_URL;
